<div class="content">
    <h3 class="standOutText" mat-dialog-title>Address Validation</h3>
    <mat-dialog-content>
        <p *ngIf="data !== null && data!== undefined && data.length > 1">We found more than one property for the address
            you submitted. Please choose the address you intend to add and click next.</p>
        <p *ngIf="data !== null && data!== undefined && data.length === 1">We found one property for the address you
            submitted. Please select the property to verify this is the address you intend to add to this client's profile and click next.</p>
        <p *ngIf="data === null || data=== undefined || data.length === 0">We were unable to verify the property address
            you submitted. Please return to the previous screen and enter a different address.</p>
        <div>
            <form [formGroup]="propertyListForm">
                <mat-radio-group class="address-radio-group" aria-label="Select an option" formControlName="property">
                    <mat-radio-button class="address-radio-button" *ngFor="let property of data" [value]="property">{{
                        property.fullAddress}}</mat-radio-button>
                </mat-radio-group>
            </form>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Back</button>
        <button mat-button class="btn btn-primary" *ngIf="data !== null" [disabled]="propertyListForm.invalid"
            (click)="onNext()">Next</button>
    </div>
</div>
